import React from 'react';

import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

import ConditionalComponent from '../../Shared/ConditionalComponent';

export const SearchBar = ({data, searchString, isServerMode, onSearch, onClear}) => {
    return (
        <div className={data.anchorEl ? 'px-4 py-2 border-t border-b border-panels-normal' : ''}>
            <div className={data.anchorEl
                ? 'flex items-center rounded-lg bg-background-normal border border-panels-normal px-3 py-1.5 gap-2'
                : 'flex flex-row rounded-3 mb-1 justify-between bg-nav-selected px-1 py-sm-1 border-1 border-classic-button-normal'
            }>
                <ConditionalComponent if={data.anchorEl}>
                    <SearchIcon sx={{color: 'var(--main-disabled-color)', fontSize: '20px', flexShrink: 0}} />
                </ConditionalComponent>
                <input
                    data-testid="select-modal-search"
                    type="text"
                    className={data.anchorEl
                        ? 'bg-transparent outline-none text-sm flex-1 text-main-normal'
                        : 'bg-transparent outline-none max-w-60'
                    }
                    placeholder={data.searchPlaceHolder}
                    value={searchString}
                    onChange={(e) => onSearch(e.target.value)}
                />
                <ConditionalComponent if={!data.anchorEl && searchString.length === 0}>
                    <SearchIcon sx={{color: 'var(--main-normal-color)', fontSize: '18px'}} />
                </ConditionalComponent>
                <ConditionalComponent if={searchString.length > 0}>
                    <button onClick={onClear}>
                        <CloseIcon sx={{color: 'var(--main-normal-color)', fontSize: '16px'}} />
                    </button>
                </ConditionalComponent>
            </div>
        </div>
    );
};
